import './review-comment.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './review-comment.html';

const MODULE_NAME = 'reviewComment';

class ReviewCommentCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventCommentChange: Function;

  // internal properties
  public comment: string;

  $onInit() {}

  onReviewChange(): void {
    this.eventCommentChange({ $event: { comment: this.comment } });
  }
}

export class ReviewComment implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    eventCommentChange: '&',
  };
  controller = [ReviewCommentCtrl];
}

export default MODULE_NAME;
